/* eslint-disable */ 
import React, { forwardRef, useEffect, useRef, useState } from 'react'

const FileInput = forwardRef((props, ref) => {
  const inputRef = useRef(null)

  const [label, setLabel] = useState('Attach file')

  useEffect(() => {
    const element = inputRef.current

    function handler() {
      const { name } = this.files[0]
      setLabel(name.length >= 10 ? `${name.substring(0, 9)}...` : name)
    }

    element.addEventListener('change', handler, false)

    return () => {
      element.removeEventListener('change', handler)
    }
  }, [])

  return (
    <label className='input-block contact-form__block mb-24'>
      <span className='contact-form__label mb-8'>
        {props.label} {props.accept && <span className='o-0-3'>(PDF only)</span>}
      </span>
      <input
        className='input-field contact-form__input'
        type='file'
        accept={props.accept}
        ref={e => {
          ref(e)
          inputRef.current = e
        }}
        {...props}
      />
      <input
        className={`filename-display contact-form__input contact-form__input--file ${props.errors &&
          'checkbox__input_err'}`}
        placeholder={label}
      />
      <div className='input-error'>Please upload a PDF file</div>
      <span className='form__icon'></span>
    </label>
  )
})

FileInput.displayName = 'FileInput'

export default FileInput
